var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7767 12.9073C11.1077 12.9073 10.4407 12.6956 9.88273 12.272L5.39773 8.80664C5.07473 8.55747 5.02473 8.10418 5.28373 7.79559C5.54473 7.48797 6.01673 7.43909 6.33873 7.6873L10.8197 11.1488C11.3827 11.5762 12.1757 11.5762 12.7427 11.145L17.1787 7.68922C17.5007 7.43718 17.9727 7.48509 18.2347 7.79368C18.4957 8.1013 18.4467 8.55364 18.1257 8.80472L13.6817 12.2662C13.1197 12.6936 12.4477 12.9073 11.7767 12.9073Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4899_19067",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.91797H22.4999V20.6055H1V1.91797Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4899_19067)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.839 19.168H16.659C16.661 19.1661 16.669 19.168 16.675 19.168C17.816 19.168 18.828 18.777 19.604 18.0343C20.505 17.1746 21 15.9393 21 14.5565V7.97464C21 5.29801 19.174 3.35547 16.659 3.35547H6.841C4.326 3.35547 2.5 5.29801 2.5 7.97464V14.5565C2.5 15.9393 2.996 17.1746 3.896 18.0343C4.672 18.777 5.685 19.168 6.825 19.168H6.839ZM6.822 20.6055C5.279 20.6055 3.901 20.0688 2.837 19.053C1.652 17.9202 1 16.3236 1 14.5565V7.97464C1 4.52176 3.511 1.91797 6.841 1.91797H16.659C19.989 1.91797 22.5 4.52176 22.5 7.97464V14.5565C22.5 16.3236 21.848 17.9202 20.663 19.053C19.6 20.0678 18.221 20.6055 16.675 20.6055H16.659H6.841H6.822Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.658acbf9d643af104390d46f2d67cdfb.svg";
export { ForwardRef as ReactComponent };